/**
 * Function to find an image with the class of .image-background and set it to the background of the parent container.
 * Should run inside a DOMContentLoaded event listener.
 *
 * @example
 * setImageBackground()
 *
 */

function setImageBackground() {
  // Array of selectors to target
  const selectors = ['.image-bg', '.billboard-1'];
  
  // Build a combined selector string for querySelectorAll
  const combinedSelector = selectors.map(selector => 
    `.user_mode .layoutContainer${selector}`
  ).join(', ');
  
  // get all the elements with any of the specified classes
  const imageBackgrounds = document.querySelectorAll(combinedSelector);

  // loop through each element
  imageBackgrounds.forEach(function (imageBackground) {
    // get the image element and check if it exists
    const imgElement = imageBackground.querySelector('.pageEl.image-bg img');
    if (!imgElement) {
      console.log('[Premier] No image element found in:', imageBackground);
      return;
    }

    // get the image url from the element
    const imgURL = 'url(' + imgElement.getAttribute('src') + ')';

    // set the background image of the parent container
    imageBackground.style.backgroundImage = imgURL;
  });
}

// function setImageBackground() {
//   // get all the elements with the class of .image-background
//   const imageBackgrounds = document.querySelectorAll('.user_mode .layoutContainer.image-bg')

//   // loop through each element
//   imageBackgrounds.forEach(function (imageBackground) {
//     // get the image element and check if it exists
//     const imgElement = imageBackground.querySelector('.pageEl.image-bg img');
//     if (!imgElement) {
//       console.log('[Premier] No image element found in:', imageBackground);
//       return;
//     }

//     // get the image url from the element
//     const imgURL = 'url(' + imgElement.getAttribute('src') + ')'

//     // set the background image of the parent container
//     imageBackground.style.backgroundImage = imgURL
//   })
// }
